var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image_fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M21,19V5a2.006,2.006,0,0,0-2-2H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19A2.006,2.006,0,0,0,21,19ZM8.5,13.5,11,16.51,14.5,12,19,18H5Z",
    fill: "#014694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFill);
export default __webpack_public_path__ + "static/media/image_fill.857fcd124a835ca2339ee3076b5fb631.svg";
export { ForwardRef as ReactComponent };